var map = {
	"./angrybanker-background.png": "26e6",
	"./angrybanker_portrait_background.png": "ec7d",
	"./badge_dropsandwins.png": "e9ce",
	"./bitcoin-perspective-signup.png": "b299",
	"./btc_games_logo.png": "41f7",
	"./cash_games_logo.png": "c220",
	"./checkbox-checkmark.png": "868d",
	"./flag-br.png": "6c19",
	"./flag-es.png": "5d30",
	"./flag-gb.png": "62e0",
	"./flag-ru.png": "5b3c",
	"./flag-sp.png": "e436",
	"./games-signin-image.png": "8540",
	"./page_not_found.png": "ecbd",
	"./rocketslot-background.png": "ce78",
	"./rocketslot_portrait_background.png": "8c76",
	"./rotate.png": "69ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "842c";